import { render, staticRenderFns } from "./RowCalls.vue?vue&type=template&id=e223b64c"
import script from "./RowCalls.vue?vue&type=script&lang=js"
export * from "./RowCalls.vue?vue&type=script&lang=js"
import style0 from "./RowCalls.vue?vue&type=style&index=0&id=e223b64c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports